import type {PermissionType} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useHasPermission} from '@hproduce/permissions'

// TODO: improve this hook. Permissions should be checked only for planner and not for Suite app.
export const usePermission = (type: PermissionType): boolean => {
  const {plantId, country: countryId} = useUpmPlantContext()
  const hasPermission = useHasPermission({plantId, countryId})
  return hasPermission(type)
}
